(() => {
  const init = (root) => {
    if (!root || root.dataset.pcfReady === 'true') return;
    root.dataset.pcfReady = 'true';

    const drawer = root.querySelector('.pcf__drawer');
    const backdrop = root.querySelector('.pcf__backdrop');
    const form = root.querySelector('.pcf__form');
    const body = root.querySelector('.pcf__drawer-body');
    const title = root.querySelector('[data-pcf-title]');
    const selection = root.querySelector('.pcf__selection');
    const backButton = root.querySelector('[data-pcf-back]');
    const panels = [...root.querySelectorAll('[data-pcf-panel]')];
    const openers = [...root.querySelectorAll('[data-pcf-open]')];
    const closeEls = [...root.querySelectorAll('[data-pcf-close]')];
    const navButtons = [...root.querySelectorAll('[data-pcf-navigate]')];
    let lastTrigger = null;
    let currentKey = '';

    if (!drawer || !form || !body) return;

    const isMobile = () => window.matchMedia('(max-width: 989px)').matches;

    const activePanel = () => panels.find((panel) => !panel.hidden);

    const updateSelection = () => {
      let count = 0;
      form.querySelectorAll('input[type="checkbox"]:checked').forEach(() => count += 1);
      const priceHasValue = [...form.querySelectorAll('input[type="number"]')].some((input) => input.value !== '');
      if (priceHasValue) count += 1;
      if (selection) selection.textContent = `${count} selected`;
    };

    const showPanel = (key, { preserveScroll = false } = {}) => {
      const panel = panels.find((item) => item.dataset.pcfPanel === key);
      if (!panel) return;
      const previousScroll = body.scrollTop;
      panels.forEach((item) => { item.hidden = item !== panel; });
      currentKey = key;
      title.textContent = panel.querySelector('h3')?.textContent || 'Filter and sort';
      if (backButton) backButton.hidden = !(isMobile() && key.startsWith('filter-'));
      requestAnimationFrame(() => {
        body.scrollTop = preserveScroll ? previousScroll : 0;
      });
    };

    const close = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      backdrop.hidden = true;
      document.documentElement.classList.remove('pcf-lock');
      openers.forEach((button) => button.setAttribute('aria-expanded', 'false'));
      if (lastTrigger) lastTrigger.focus({ preventScroll: true });
    };

    const open = (key, trigger) => {
      lastTrigger = trigger || null;
      showPanel(key);
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      backdrop.hidden = false;
      document.documentElement.classList.add('pcf-lock');
      openers.forEach((button) => button.setAttribute('aria-expanded', String(button === trigger)));
      requestAnimationFrame(() => drawer.querySelector('[data-pcf-close]')?.focus({ preventScroll: true }));
    };

    openers.forEach((button) => button.addEventListener('click', () => open(button.dataset.pcfOpen, button)));
    navButtons.forEach((button) => button.addEventListener('click', () => showPanel(button.dataset.pcfNavigate)));
    backButton?.addEventListener('click', () => showPanel('filters-index'));
    closeEls.forEach((element) => element.addEventListener('click', close));

    // Keep native form controls inside their visible option cards. This avoids
    // double-toggling checkboxes and prevents the browser from scrolling a
    // visually-hidden control into view when a lower sort option is selected.
    let preservedDrawerScroll = 0;
    let preservedPageScroll = 0;
    form.querySelectorAll('.pcf__sort-option input, .pcf__option input').forEach((input) => {
      const rememberScroll = () => {
        preservedDrawerScroll = body.scrollTop;
        preservedPageScroll = window.scrollY;
      };
      input.addEventListener('pointerdown', rememberScroll, { passive: true });
      input.addEventListener('keydown', rememberScroll);
      input.addEventListener('change', () => {
        updateSelection();
        requestAnimationFrame(() => {
          body.scrollTop = preservedDrawerScroll;
          window.scrollTo({ top: preservedPageScroll, left: window.scrollX, behavior: 'auto' });
          input.blur();
        });
      });
    });

    root.querySelectorAll('[data-pcf-reset-panel]').forEach((button) => {
      button.addEventListener('click', () => {
        const panel = button.closest('[data-pcf-panel]');
        if (!panel) return;
        panel.querySelectorAll('input[type="checkbox"]').forEach((input) => { input.checked = false; });
        panel.querySelectorAll('input[type="number"]').forEach((input) => { input.value = ''; });
        updateSelection();
      });
    });

    root.querySelector('[data-pcf-reset-all]')?.addEventListener('click', () => {
      form.querySelectorAll('input[type="checkbox"]').forEach((input) => { input.checked = false; });
      form.querySelectorAll('input[type="number"]').forEach((input) => { input.value = ''; });
      const defaultSort = form.querySelector('input[type="radio"][name="sort_by"]');
      if (defaultSort) {
        form.querySelectorAll('input[type="radio"][name="sort_by"]').forEach((input) => { input.checked = false; });
        defaultSort.checked = true;
      }
      updateSelection();
      body.scrollTop = 0;
    });

    form.querySelectorAll('input[type="number"]').forEach((input) => input.addEventListener('input', updateSelection));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    updateSelection();
  };

  const initAll = () => document.querySelectorAll('[data-pcf]').forEach(init);
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  initAll();
})();
